import { ApiPackageModelDefinition } from '@ibe/api';

class PackageListEvent {
  packages: ApiPackageModelDefinition[] | null;
}

export default PackageListEvent;
